var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import AudioRecord from '../audioRecord/AudioRecord';
import FilesComponent from 'components/files/files';
const QuestionAudio = (props) => {
    const { durationTime, durationUnit, initialState, getLocalAnswers, getRawAnswer, questionId, question } = props;
    const [textAnswer, setTextAnswer] = useState(undefined);
    const [userAnswer, setUserAnswer] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        setTextAnswer(undefined);
        if (!initialState || !(initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer)) {
            return;
        }
        if (getRawAnswer(question).userAnswer) {
            setUserAnswer(true);
        }
        setTextAnswer(initialState.userAnswer);
    }, [initialState]);
    useEffect(() => {
        if (textAnswer === undefined) {
            return;
        }
        getLocalAnswers(textAnswer);
    }, [textAnswer]);
    return (_jsxs(_Fragment, { children: [_jsx(AudioRecord, Object.assign({}, props, { uploadRecording: (pathUrl) => __awaiter(void 0, void 0, void 0, function* () {
                    if (pathUrl) {
                        setTextAnswer(pathUrl);
                    }
                    return '';
                }) }), void 0), _jsx("div", Object.assign({ className: "container--tiles" }, { children: !userAnswer && (_jsx("div", Object.assign({ className: "tile tile--gray" }, { children: _jsxs("div", Object.assign({ className: "tile__content" }, { children: [_jsxs("div", Object.assign({ className: "tile__icon" }, { children: [_jsx("i", { className: "fas fa-clock" }, void 0), _jsx(FontAwesomeIcon, { icon: faClock }, void 0)] }), void 0), _jsxs("div", Object.assign({ className: "tile__title" }, { children: [_jsx("h6", { children: t('QUESTION.AUDIO.DURATION') }, void 0), _jsx("span", Object.assign({ className: "tile__subtitle" }, { children: t('QUESTION.AUDIO.DURATION_DESCRIPTION', { time: durationTime, unit: t(`GENERAL.${durationUnit}`, { count: durationTime }).toLowerCase() }) }), void 0)] }), void 0)] }), void 0) }), void 0)) }), void 0), props.instructionsFile && (_jsx(FilesComponent, { file: props.instructionsFile }, void 0))] }, void 0));
};
export default QuestionAudio;
